import * as React from 'react';
import { IMapFirstPaintOptions } from '@cian/frontend-newbuilding-map-component';

export type TMapFirstPaintPartialOptions = Pick<
  IMapFirstPaintOptions,
  'controls' | 'zoomRange' | 'id' | 'styles' | 'disableScrollZoom' | 'displayRouteInfo'
>;

export function useMapFirstPaintPartialOptions(onRulerClick?: () => void) {
  return React.useMemo<TMapFirstPaintPartialOptions>(
    () => ({
      disableScrollZoom: true,
      displayRouteInfo: true,
      id: 'infrastructure-map',
      styles: { width: '100%', height: '100%' },
      controls: [
        { type: 'ZoomControl' },
        { type: 'RulerControl', onClick: onRulerClick },
        { type: 'GeolocationControl' },
        { type: 'FullscreenControl' },
        { type: 'PanoramaControl' },
      ],
      zoomRange: { min: 1, max: 17 },
    }),
    [onRulerClick],
  );
}
